/**
 * Call to action
 */
import React from 'react';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { lookupsState } from '../redux/lookupsSlice';

const useStyles = makeStyles(() => ({
  root: {
    textAlign: 'center',
    marginTop: 60,
  },
  subTitle: {
    fontSize: '1.2em',
    margin: '20px 0 30px 0',
  },
  ctaAction: {
    margin: '20px 0',
  },
}));

/**
 * Call to action
 * @returns {JSX.Element}
 */
function CallToAction() {
  const { configuration } = useSelector(lookupsState);
  const { t } = useTranslation();
  const classes = useStyles();
  const title = t('Are you in a hurry to sell?');
  const subTitle = t('Our consultants are at your disposal');
  const ctaTitle = t('Call us immediately');

  return (
    <div className={classes.root}>
      <h1>{title}</h1>
      <div className={classes.subTitle}>{subTitle}</div>
      <button
        type="button"
        className={`ga-button-default ${classes.ctaAction}`}
        onClick={() => {
          window.location = `tel:${configuration.contact.phone}`;
          return true;
        }}
      >
        {ctaTitle}
      </button>
    </div>
  );
}

export default CallToAction;
